<template>
  <div v-if="show" class="loader">
    <div v-if="showIcon" :class="iconClass"></div>
    <div class="loader__spinner"></div>
  </div>
</template>

<script lang="ts">
import {
  Component, Prop, Vue, Watch
} from 'vue-property-decorator';

@Component
export default class LoaderComponent extends Vue {
  @Prop({ default: true })
  public show!: boolean;

  @Prop({ default: 'loader__icon loader__icon--car' })
  public iconClass!: string;

  public get showIcon() {
    return this.iconClass.length > 0;
  }
}
</script>
